import React from "react";
import { FlyerDetailPageViewProps } from "./flyer-detail-page-view.props";
import { SpinnerLoader } from "../../../../../../../../components/loaders";
import { FlyerDetailPageEditView } from "../flyer-detail-page-edit-view/flyer-detail-page-edit-view.component";
import { FlyerDetailPageEditViewProps } from "../flyer-detail-page-edit-view/flyer-detail-page-edit-view.props";
import { BriefErrorMessage } from "../../../../../../../../components/brief/BriefErrorMessage";

export const FlyerDetailPageView = (props: FlyerDetailPageViewProps) => {
  if (!props.permissions && !props.error) {
    return null;
  }

  return (
    <>
      <SpinnerLoader showIf={props.isLoading} hasBackdrop={true} />
      <BriefErrorMessage showIf={Boolean(props.error)} errors={props.error!} />
      <FlyerDetailPageEditView
        showIf={Boolean(props.pageTemplate) && !Boolean(props.error)}
        {...(props as FlyerDetailPageEditViewProps)}
      />
    </>
  );
};
